import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _CloseIcon, _SkholeIcon;
var _excluded = ["className", "children", "isLabelDisplayed", "classes", "SelectProps"],
  _excluded2 = ["id", "className", "value", "onSearchChange", "clearSearch"],
  _excluded3 = ["className", "styles", "classes", "inputPropsClasses", "meta", "meta"],
  _excluded4 = ["className", "styles", "classes", "inputPropsClasses", "meta", "meta"],
  _excluded5 = ["className", "styles"],
  _excluded6 = ["className", "title", "onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import CloseIcon from '@mui/icons-material/Close';
import { fieldArrayPropTypes } from 'redux-form';
import noop from 'lodash/noop';
import AsyncAutocomplete from '../../AsyncAutocomplete/AsyncAutocomplete';
import AsyncAutocompleteArray from '../../AsyncAutocompleteArray/AsyncAutocompleteArray';
import Autocomplete from '../../Autocomplete/Autocomplete';
import SkholeIcon01 from '../Icons/SkholeIcon01';
import SkholeIcon17 from '../Icons/SkholeIcon17';
import SkholeIcon42 from '../Icons/SkholeIcon42';
import ContextProvider from '../../../context';
import s from './Forms.scss';
var SelectField = function SelectField(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$isLabelDisplayed = _ref.isLabelDisplayed,
    isLabelDisplayed = _ref$isLabelDisplayed === void 0 ? false : _ref$isLabelDisplayed,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? {} : _ref$classes,
    _ref$SelectProps = _ref.SelectProps,
    SelectProps = _ref$SelectProps === void 0 ? {} : _ref$SelectProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TextField, _extends({
    className: classNames(className),
    InputLabelProps: {
      classes: {
        formControl: classNames(isLabelDisplayed ? s.labelOn : s.labelOff)
      }
    },
    InputProps: {
      classes: {
        root: classNames(s.textField, classes.textField)
      }
    },
    classes: {
      root: classNames(s.formRoot, classes.formRoot)
    },
    select: true,
    margin: "none",
    SelectProps: _objectSpread({
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: function IconComponent() {
        return /*#__PURE__*/_jsx(SkholeIcon42, {
          className: classNames(s.selectIcon, classes.selectIcon)
        });
      },
      classes: {
        selectMenu: s.selectMenu,
        select: classes.select,
        root: classNames(classes.selectRoot)
      }
    }, SelectProps)
  }, rest), children);
};
var SearchField = function SearchField(_ref2) {
  var _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? '' : _ref2$id,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? '' : _ref2$value,
    _ref2$onSearchChange = _ref2.onSearchChange,
    onSearchChange = _ref2$onSearchChange === void 0 ? noop : _ref2$onSearchChange,
    _ref2$clearSearch = _ref2.clearSearch,
    clearSearch = _ref2$clearSearch === void 0 ? false : _ref2$clearSearch,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(TextField, _extends({
    className: className,
    onChange: onSearchChange,
    value: value
  }, rest, {
    InputLabelProps: {
      classes: {
        formControl: s.labelOff
      }
    },
    inputProps: {
      id: id
    },
    InputProps: {
      classes: {
        root: s.searchInputRoot,
        input: s.textFieldInput
      },
      endAdornment: clearSearch && value ? /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "NDEPBehLOsKteA8Gi2U8Q",
        className: s.icon,
        onClick: clearSearch
      }, void 0, _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx(CloseIcon, {}))) : /*#__PURE__*/_jsx(IconButton, {}, void 0, /*#__PURE__*/_jsx(SkholeIcon01, {
        className: s.searchIcon
      }))
    },
    classes: {
      root: s.searchRoot
    }
  }));
};
var StyledAsyncAutocomplete = function StyledAsyncAutocomplete(_ref3) {
  var _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$styles = _ref3.styles,
    styles = _ref3$styles === void 0 ? false : _ref3$styles,
    _ref3$classes = _ref3.classes,
    classes = _ref3$classes === void 0 ? {} : _ref3$classes,
    _ref3$inputPropsClass = _ref3.inputPropsClasses,
    inputPropsClasses = _ref3$inputPropsClass === void 0 ? {} : _ref3$inputPropsClass,
    _ref3$meta = _ref3.meta,
    _ref3$meta2 = _ref3$meta === void 0 ? {} : _ref3$meta,
    error = _ref3$meta2.error,
    touched = _ref3$meta2.touched,
    submitFailed = _ref3$meta2.submitFailed,
    _ref3$meta3 = _ref3.meta,
    meta = _ref3$meta3 === void 0 ? {} : _ref3$meta3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var context = useContext(ContextProvider);
  return /*#__PURE__*/React.createElement(AsyncAutocomplete, _extends({
    margin: "none",
    meta: meta,
    InputProps: {
      classes: _objectSpread(_objectSpread({}, inputPropsClasses), {}, {
        root: classNames(s.textField, inputPropsClasses.root, _defineProperty({}, s.error, !!((touched || submitFailed) && error)))
      })
    },
    InputLabelProps: {
      classes: {
        formControl: s.labelOff
      }
    },
    className: s.asyncMenu,
    classes: _objectSpread({
      root: classNames(s.formRoot, className)
    }, classes),
    styles: styles || context.primaryAutocompleteStyles
  }, rest));
};
var StyledAsyncAutocompleteArray = function StyledAsyncAutocompleteArray(_ref4) {
  var _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className,
    _ref4$styles = _ref4.styles,
    styles = _ref4$styles === void 0 ? false : _ref4$styles,
    _ref4$classes = _ref4.classes,
    classes = _ref4$classes === void 0 ? {} : _ref4$classes,
    _ref4$inputPropsClass = _ref4.inputPropsClasses,
    inputPropsClasses = _ref4$inputPropsClass === void 0 ? {} : _ref4$inputPropsClass,
    _ref4$meta = _ref4.meta,
    meta = _ref4$meta === void 0 ? {} : _ref4$meta,
    _ref4$meta2 = _ref4.meta,
    _ref4$meta3 = _ref4$meta2 === void 0 ? {} : _ref4$meta2,
    error = _ref4$meta3.error,
    touched = _ref4$meta3.touched,
    submitFailed = _ref4$meta3.submitFailed,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var context = useContext(ContextProvider);
  return /*#__PURE__*/React.createElement(AsyncAutocompleteArray, _extends({
    margin: "none",
    InputProps: {
      classes: _objectSpread(_objectSpread({}, inputPropsClasses), {}, {
        root: classNames(s.textField, inputPropsClasses.root, _defineProperty({}, s.error, !!((touched || submitFailed) && error)))
      })
    },
    meta: meta,
    InputLabelProps: {
      classes: {
        formControl: s.labelOff
      }
    },
    className: s.asyncMenu,
    classes: _objectSpread({
      root: classNames(s.formRoot, className)
    }, classes),
    styles: styles || context.primaryAutocompleteStyles
  }, rest));
};
var StyledAutocomplete = function StyledAutocomplete(_ref5) {
  var _ref5$className = _ref5.className,
    className = _ref5$className === void 0 ? '' : _ref5$className,
    _ref5$styles = _ref5.styles,
    styles = _ref5$styles === void 0 ? false : _ref5$styles,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  var context = useContext(ContextProvider);
  return /*#__PURE__*/React.createElement(Autocomplete, _extends({
    margin: "none",
    InputProps: {
      classes: {
        root: s.textField
      }
    },
    InputLabelProps: {
      classes: {
        formControl: s.labelOff
      }
    },
    classes: {
      root: classNames(s.formRoot, className)
    },
    styles: styles || context.primaryAutocompleteStyles
  }, rest));
};
var StyledAddNewButton = function StyledAddNewButton(_ref6) {
  var _ref6$className = _ref6.className,
    className = _ref6$className === void 0 ? '' : _ref6$className,
    _ref6$title = _ref6.title,
    title = _ref6$title === void 0 ? '' : _ref6$title,
    onClick = _ref6.onClick,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsx("div", {
    className: classNames(s.addBtn, className)
  }, void 0, /*#__PURE__*/_jsx(Tooltip, {
    title: title,
    enterDelay: 300
  }, void 0, /*#__PURE__*/React.createElement(Button, _extends({
    "data-test-id": "fdbh_eTMCp_hN4FVKBvyM",
    color: "primary",
    className: s.addIcon
    // classes={{
    //   root: s.btnRoot,
    // }}
    ,
    onClick: onClick
  }, rest), _SkholeIcon || (_SkholeIcon = /*#__PURE__*/_jsx(SkholeIcon17, {})))));
};
var ActiveArchivedGroup = function ActiveArchivedGroup(_ref7) {
  var value = _ref7.value,
    onArchivedClick = _ref7.onArchivedClick,
    onActiveClick = _ref7.onActiveClick,
    _ref7$labels = _ref7.labels,
    archivedLabel = _ref7$labels.archived,
    activeLabel = _ref7$labels.active,
    _ref7$classes = _ref7.classes,
    classes = _ref7$classes === void 0 ? {} : _ref7$classes;
  return /*#__PURE__*/_jsx(FormControl, {
    component: "fieldset",
    classes: {
      root: classNames(s.fieldSet, classes.fieldSet)
    }
  }, void 0, /*#__PURE__*/_jsx(RadioGroup, {
    "aria-label": "archived",
    name: "archived",
    className: s.group,
    value: value,
    row: true
  }, void 0, /*#__PURE__*/_jsx(FormControlLabel, {
    "data-test-id": "4K7fRJH1PRIrwnzkDlPo_",
    value: "false",
    classes: {
      root: s.checkRoot,
      label: s.checkLabel
    },
    control: /*#__PURE__*/_jsx(Radio, {
      color: "primary",
      classes: {
        root: s.radioRoot
      }
    }),
    onClick: onActiveClick,
    label: activeLabel
  }), /*#__PURE__*/_jsx(FormControlLabel, {
    "data-test-id": "GF7YIdjfN8_DsTTUTZdx1",
    value: "true",
    classes: {
      root: s.checkRoot,
      label: s.checkLabel
    },
    control: /*#__PURE__*/_jsx(Radio, {
      color: "primary",
      classes: {
        root: s.radioRoot
      }
    }),
    onClick: onArchivedClick,
    label: archivedLabel
  })));
};
export var ToolbarActiveArchivedGroup = withStyles(s)(ActiveArchivedGroup);
export var ToolbarSelectField = withStyles(s)(SelectField);
export var ToolbarSearchField = withStyles(s)(SearchField);
export var ToolbarAsyncAutocompleteArray = withStyles(s)(StyledAsyncAutocompleteArray);
export var ToolbarAsyncAutocomplete = withStyles(s)(StyledAsyncAutocomplete);
export var ToolbarAutocomplete = withStyles(s)(StyledAutocomplete);
export var ToolbarAddNewBtn = withStyles(s)(StyledAddNewButton);